import { render, staticRenderFns } from "./SituationShareholderBlock.vue?vue&type=template&id=715941ac"
import script from "./SituationShareholderBlock.vue?vue&type=script&lang=js"
export * from "./SituationShareholderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports